import { LOGOUT__DIALOG__MUTATIONS } from "../mutation-types";
import { LOGOUT__DIALOG__ACTIONS } from '../action-types'

// State
const state = {
  dialog: false,
};

// Mutations
const mutations = {
  [LOGOUT__DIALOG__MUTATIONS.SHOW_DIALOG](state) {
    state.dialog = true;
  },
  [LOGOUT__DIALOG__MUTATIONS.HIDE_DIALOG](state) {
    state.dialog = false;
  },
};

const getters = {};


// Actions
const actions = {
  [LOGOUT__DIALOG__ACTIONS.SHOWDIALOG]({ commit }) {
    commit(LOGOUT__DIALOG__MUTATIONS.SHOW_DIALOG);
  },
  [LOGOUT__DIALOG__ACTIONS.HIDEDIALOG]({ commit }) {
    commit(LOGOUT__DIALOG__MUTATIONS.HIDE_DIALOG);
  },
};


export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
